import {
  Activity,
  AlertTriangle,
  ArrowDown,
  Award,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Banknote,
  Bell,
  BellOff,
  Building2,
  Calendar,
  Camera,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUpDown,
  ChevronUp,
  Clock,
  Copy,
  CreditCard,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  FileText,
  Filter,
  Flag,
  Globe,
  GripVertical,
  Hash,
  Heart,
  HeartPulse,
  HelpCircle,
  Home,
  Image,
  Inbox,
  Info,
  LayoutGrid,
  List,
  Loader2,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  Mic,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  PanelLeft,
  MoreVertical,
  Package,
  Paperclip,
  Pencil,
  Percent,
  Phone,
  Plus,
  Radar,
  Receipt,
  RefreshCw,
  Search,
  Send,
  Settings,
  ShieldCheck,
  Share2,
  ShoppingBag,
  ShoppingCart,
  SlidersHorizontal,
  Sparkles,
  Star,
  Store,
  Sun,
  Tag,
  Trash2,
  Truck,
  Undo2,
  Unlock,
  Upload,
  User,
  Users,
  Wallet,
  Wrench,
  X,
} from "lucide-react";

// Add new Lucide icons here so imports stay explicit and tree-shakeable.
export const ICONS = {
  Activity,
  AlertTriangle,
  ArrowDown,
  Award,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Banknote,
  Bell,
  BellOff,
  Building2,
  Calendar,
  Camera,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUpDown,
  ChevronUp,
  Clock,
  Copy,
  CreditCard,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  FileText,
  Filter,
  Flag,
  Globe,
  GripVertical,
  Hash,
  Heart,
  HeartPulse,
  HelpCircle,
  Home,
  Image,
  Inbox,
  Info,
  LayoutGrid,
  List,
  Loader2,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  Mic,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  PanelLeft,
  MoreVertical,
  Package,
  Paperclip,
  Pencil,
  Percent,
  Phone,
  Plus,
  Radar,
  Receipt,
  RefreshCw,
  Search,
  Send,
  Settings,
  ShieldCheck,
  Share2,
  ShoppingBag,
  ShoppingCart,
  SlidersHorizontal,
  Sparkles,
  Star,
  Store,
  Sun,
  Tag,
  Trash2,
  Truck,
  Undo2,
  Unlock,
  Upload,
  User,
  Users,
  Wallet,
  Wrench,
  X,
};
